export function getdata() {
	var obj = {
		
			headData: [{
					title: "外国企业名称（中文）",
					prop:'sdsA_4_x_1',
					width: "200px",
					custom: true,
				},
				{
					title: "成立地（中文",
					prop:'sdsA_4_x_2',
					width: "300px",
					custom: true,
				},
				{
					title: "外国企业名称（外文）",
					prop:'sdsA_4_x_3',
					width: "300px",
					custom: true,
				},
				{
					title: "成立地（外文）",
					prop:'sdsA_4_x_4',
					width: "300px",
					custom: true,
				},
				{
					title: "所在国纳税识别号",
					prop:'sdsA_4_x_5',
					width: "300px",
					custom: true,
				},
				{
					title: "主营业务类型",
					prop:'sdsA_4_x_6',
					width: "300px",
					custom: true,
				},
				
			],
			tableData: [{
					disabledsdsA_4_x_1:false,
					disabledsdsA_4_x_2:false,
					disabledsdsA_4_x_3:false,
					disabledsdsA_4_x_4:false,
					disabledsdsA_4_x_5:false,
					disabledsdsA_4_x_6:false,
					sdsA_4_x_1: {
						cellCode:"sdsA_4_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_4_x_2: {
						cellCode:"sdsA_4_1_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_4_x_3: {
						cellCode:"sdsA_4_1_3",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_4_x_4: {
						cellCode:"sdsA_4_1_4",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_4_x_5: {
						cellCode:"sdsA_4_1_5",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_4_x_6: {
						cellCode:"sdsA_4_1_6",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					disabledsdsA_4_x_1:false,
					disabledsdsA_4_x_2:false,
					disabledsdsA_4_x_3:false,
					disabledsdsA_4_x_4:false,
					disabledsdsA_4_x_5:false,
					disabledsdsA_4_x_6:false,
					sdsA_4_x_1: {
						cellCode:"sdsA_4_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_4_x_2: {
						cellCode:"sdsA_4_2_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_4_x_3: {
						cellCode:"sdsA_4_2_3",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_4_x_4: {
						cellCode:"sdsA_4_2_4",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_4_x_5: {
						cellCode:"sdsA_4_2_5",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_4_x_6: {
						cellCode:"sdsA_4_2_6",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					disabledsdsA_4_x_1:false,
					disabledsdsA_4_x_2:false,
					disabledsdsA_4_x_3:false,
					disabledsdsA_4_x_4:false,
					disabledsdsA_4_x_5:false,
					disabledsdsA_4_x_6:false,
					sdsA_4_x_1: {
						cellCode:"sdsA_4_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_4_x_2: {
						cellCode:"sdsA_4_3_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_4_x_3: {
						cellCode:"sdsA_4_3_3",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_4_x_4: {
						cellCode:"sdsA_4_3_4",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_4_x_5: {
						cellCode:"sdsA_4_3_5",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_4_x_6: {
						cellCode:"sdsA_4_3_6",
						cellType:"1",
						cellVal:"240040043.08"
					},
				}
			]
		
	}
	return obj
}
